import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Grid,
	Table,
	TableContainer,
	TableBody,
	TableRow,
	TableCell,
} from "@mui/material";
import useStore from "../store/store";
import style from "../utils/style";
import utils from "../utils/utils";
import accountService from "../services/account";
import Confirm from "./Confirm";
import { ArrowUp, ArrowDown } from "./Arrows";
import PageHeading from "./PageHeading";

function AccountDetails({ reload, toggleDrawer, setIsNew }) {
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();

	const {
		token,
		setErrorMessage,
		setInfoMessage,
		setSuccessMessage,
		setIsLoading,
		currObj,
		setToEdit,
	} = useStore((state) => state);

	const editRecord = () => {
		setToEdit(true);
		setIsNew(true);
	};

	const deleteRecord = () => {
		setIsLoading(true);
		accountService
			.delete(token, currObj?._id)
			.then((res) => {
				if (res.error) {
					setErrorMessage(res.error);
					setIsLoading(false);
					return;
				}

				if (res.data === true)
					setSuccessMessage("Account deleted successfully.");
				else setInfoMessage(res.data);
				setIsOpen(false);
				setIsLoading(false);
				reload();
				toggleDrawer();
			})
			.catch((err) => {
				setErrorMessage(err.message);
			});
	};

	return (
		<>
			<Confirm
				open={isOpen}
				onNo={() => {
					setIsOpen(false);
				}}
				onYes={() => {
					setIsOpen(false);
					deleteRecord();
				}}
				title="Are you sure?"
				body="This account will be deleted."
			/>

			<Grid container sx={style.container}>
				<Grid item xs={12} md={12}>
					<PageHeading text="Details" />
				</Grid>

				<Grid item xs={12}>
					<TableContainer>
						<Table>
							<TableBody>
								{currObj && currObj.title && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="person-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											{currObj.title}
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj.phone && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="call-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											<a href={`tel:${currObj.phone}`}>
												{currObj.phone}
											</a>
										</TableCell>
									</TableRow>
								)}
								{currObj && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											{currObj.debit !== 0 && (
												<>
													<ArrowUp
														style={{
															fontSize: "20px",
														}}
													/>
												</>
											)}{" "}
											{currObj.credit !== 0 && (
												<>
													<ArrowDown
														style={{
															fontSize: "20px",
														}}
													/>
												</>
											)}
											{currObj.debit === 0 &&
												currObj.credit === 0 && (
													<>
														<ArrowDown
															style={{
																fontSize:
																	"20px",
															}}
														/>
													</>
												)}
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											{utils.formatToCurrency(
												Math.abs(
													currObj.debit ||
														currObj.credit ||
														0
												),
												"Rs. "
											)}
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj.shopName && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="storefront-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											{currObj.shopName}
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj.address && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="location-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											{currObj.address}
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj.nickName && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
										}}
									>
										<TableCell align="right">
											<ion-icon
												name="happy-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											{currObj.nickName}
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj._id && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
											cursor: "pointer",
										}}
										onClick={() =>
											navigate(
												`/transaction-history/id=${currObj._id}`
											)
										}
									>
										<TableCell align="right">
											<ion-icon
												name="search-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											Transactions History
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj._id && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
											cursor: "pointer",
										}}
										onClick={editRecord}
									>
										<TableCell align="right">
											<ion-icon
												name="create-outline"
												style={style.accDetailIcons}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={style.accDetailText}
											component="th"
											scope="row"
											align="left"
										>
											Edit
										</TableCell>
									</TableRow>
								)}
								{currObj && currObj._id && (
									<TableRow
										sx={{
											"&:last-child td, &:last-child th":
												{
													border: 0,
												},
											cursor: "pointer",
										}}
										onClick={() => setIsOpen(true)}
									>
										<TableCell align="right">
											<ion-icon
												name="trash-outline"
												style={{
													...style.accDetailIcons,
													color: "red",
												}}
											></ion-icon>
										</TableCell>
										<TableCell
											sx={{
												...style.accDetailText,
												color: "red",
											}}
											component="th"
											scope="row"
											align="left"
										>
											Delete
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</>
	);
}

export default AccountDetails;
